import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const Notification = ({
  message = '',
  title = '',
  setFilterInstance = null,
  icon = null,
  iconColor = null,
  action = null,
}) => {
  const [showNotification, setShowNotification] = useState(true);
  const [isFilterPending, setIsFilterPending] = useState(true);

  useEffect(() => {
    if (message) setShowNotification(true);
  }, [message]);

  const handleButtonClick = () => {
    if (setFilterInstance) {
      setFilterInstance({
        columnName: 'requestEmailDate',
        filterValue: isFilterPending ? 'pending' : '',
      });
      setIsFilterPending((prev) => !prev);
    }
  };

  const formatMessage = (text) => {
    const matches = text.match(/[^()]+\([^()]+\)/g);
    if (!matches) return text;

    const allMatchesLength = matches.reduce(
      (total, match) => total + match.length,
      0,
    );
    const hasAdditionalText = text.length > allMatchesLength;

    if (hasAdditionalText) {
      return text;
    }

    const limitedMatches = matches.slice(0, 3);
    const isTruncated = matches.length > 3;

    return (
      <>
        {limitedMatches.map((part, index) => (
          <span key={index}>
            {part}
            <br />
          </span>
        ))}
        {isTruncated && <span>...</span>}
      </>
    );
  };

  const containsKeyword = ['required', 'error', 'unsaved'].some((word) =>
    [message, title].some((text) => text.toLowerCase().includes(word)),
  );

  const getIconConfig = () => {
    if (icon && iconColor) {
      return {
        icon,
        colorClass: iconColor,
        isBootstrapIcon: icon.startsWith('bi-'),
      };
    }

    if (containsKeyword) {
      return {
        icon: 'bi-exclamation-triangle-fill',
        colorClass: 'text-danger',
        isBootstrapIcon: true,
      };
    }
    return {
      icon: 'bi-check-circle-fill',
      colorClass: 'text-success',
      isBootstrapIcon: true,
    };
  };

  const iconConfig = getIconConfig();

  return (
    showNotification && (
      <div className="notification-container">
        <Alert
          variant="danger"
          className="notification d-flex align-items-center"
        >
          <button
            type="button"
            className="btn-close"
            aria-label="Close alert"
            onClick={() => setShowNotification(false)}
          >
            &times;
          </button>

          <div className={`icon-container me-3 ${iconConfig.colorClass}`}>
            <span
              className={`${iconConfig.isBootstrapIcon ? 'bi' : 'fas'} ${iconConfig.icon} fs-2`}
            />
          </div>

          <div className="media">
            <div className="media-body">
              {title && (
                <div className="d-flex align-items-center">
                  <h5 className="mt-1 mb-2 text-white me-2">{title}</h5>
                </div>
              )}

              <p className="mt-1 mb-0">{formatMessage(message)}</p>

              {action && (
                <button
                  type="button"
                  className="btn btn-link text-white p-0 mt-1"
                  style={{ textDecoration: 'underline', fontSize: '0.9rem' }}
                  onClick={action.onClick}
                >
                  {action.label}
                </button>
              )}

              {title && setFilterInstance && (
                <div className="text-end mt-2">
                  <button
                    type="button"
                    className="btn btn-light btn-sm px-3 mt-2"
                    onClick={handleButtonClick}
                  >
                    {isFilterPending ? 'Apply Filter 🙂' : 'Clear Filter 🙂'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </Alert>
      </div>
    )
  );
};

Notification.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  setFilterInstance: PropTypes.func,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  action: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

export default Notification;
